export default "__VITE_ASSET__DzBgt4rI__"